import Swiper, { Scrollbar, Autoplay } from 'swiper'

export default function sliderSwiperMobile() {
	const megaBiteProductSlider = new Swiper('.swiper__image-megabite-mobile', {
		// Optional parameters
		loop: true,

		modules: [Scrollbar, Autoplay],
		scrollbar: {
			el: '.swiper-scrollbar',
			hide: false,
		},
		autoplay: {
			delay: 3000,
			disableOnInteraction: true,
		},
	}).mount()
}
